import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Provider, ProviderEntity } from '../../../../models/provider';
import { commonMessages } from '../../../../components/atoms/CommonMessages/messages';
import { ContentBody } from '../../../../components/atoms/ContentBody/ContentBody';
import { TintedScreenWrapper } from '../../../../components/atoms/ScreenWrapper/ScreenWrapper';
import { LoadingSpinner } from '../../../../components/atoms/LoadingSpinner/LoadingSpinner';
import { Caption } from '../../../../components/atoms/Text/Text';
import { Button } from '../../../../components/atoms/Button/Button';
import { Credentials, CredentialsEntity } from '../../../../models/credentials';
import { messages as awaitingMessages } from '../../../../components/screens/AwaitingCredentialsScreen/messages';
import { H2 } from '../../../../components/atoms/Heading/Heading';
import { messages } from '../../../messages';
import { StyledNarrowCenteredContainer } from './HandoffCodeScanned.styles';

const getSubtitle = (isUpdating: boolean, isMobileBankId: boolean, providerName: string) => {
  if (!isUpdating) {
    const updatedProviderName = isMobileBankId ? 'BankID' : providerName;

    return (
      <FormattedMessage
        {...messages.codeScannedInstructions}
        values={{ providerName: updatedProviderName }}
      />
    );
  }

  return <FormattedMessage {...awaitingMessages.connectingTo} values={{ providerName }} />;
};

export type HandoffCodeScannedViewProps = {
  provider: ProviderEntity;
  credentials?: CredentialsEntity;
  onClick: () => void;
};

export const HandoffCodeScannedView: React.FC<HandoffCodeScannedViewProps> = ({
  credentials,
  provider,
  onClick,
}) => {
  const { displayName } = provider;
  const isUpdating = Boolean(Credentials.isUpdating(credentials));
  const isMobileBankFlowId = Provider.isMobileBankId(provider);

  return (
    <TintedScreenWrapper>
      <ContentBody centerVertically>
        <StyledNarrowCenteredContainer>
          <LoadingSpinner />
          <H2>
            <FormattedMessage {...messages.codeScannedTitle} />
          </H2>
          <Caption>{getSubtitle(isUpdating, isMobileBankFlowId, displayName)}</Caption>
          <Button color="primary" data-testid="handoff-cancel-ongoing" onClick={onClick}>
            <FormattedMessage {...commonMessages.cancel} />
          </Button>
        </StyledNarrowCenteredContainer>
      </ContentBody>
    </TintedScreenWrapper>
  );
};
